import { useState, useEffect } from "react";

interface LaunchCountdownProps {
  readonly targetDate: Date;
}

function getRemaining(target: Date): {
  days: number;
  hours: number;
  minutes: number;
  expired: boolean;
} {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, expired: true };
  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return { days, hours, minutes, expired: false };
}

export function LaunchCountdown({ targetDate }: LaunchCountdownProps) {
  const [remaining, setRemaining] = useState(() => getRemaining(targetDate));

  useEffect(() => {
    const interval = setInterval(
      () => setRemaining(getRemaining(targetDate)),
      1000,
    );
    return () => clearInterval(interval);
  }, [targetDate]);

  if (remaining.expired) {
    return (
      <span className="text-lg font-black text-emerald-600">Lancé !</span>
    );
  }

  const isUrgent = remaining.days < 7;
  const display =
    remaining.days >= 1
      ? `${remaining.days}j ${remaining.hours}h`
      : `${remaining.hours}h ${remaining.minutes}m`;

  return (
    <span
      className={`text-2xl font-black tabular-nums leading-none ${isUrgent ? "text-red-600" : "text-[#c2642a]"}`}
    >
      {display}
    </span>
  );
}
